import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'; // Импортируем стили
import style from './style.module.scss';

interface NewsSkeletonProps {
  count: number;
}

export const FavoritesSkeleton = ({ count }: NewsSkeletonProps) => {
  return (
      <div className={style.list}>
        {[...Array(count)].map((_, index) => (
          <div className={style.item} key={index}>
            <Skeleton className={style.poster} width={300} height={239} />{' '}
          </div>
        ))}
      </div>
  );
};
